// src/js/components/Notification.js

export default class Notification {
  static container = null;

  // Ensure container exists
  static ensureContainer() {
    if (!this.container) {
      this.container = document.createElement("div");
      this.container.className = "toast-container";
      document.body.appendChild(this.container);
    }
  }

  // Show a toast
  static show(message, type = "info", timeout = 3000) {
    this.ensureContainer();

    const toast = document.createElement("div");
    toast.className = `toast toast-${type}`;
    toast.textContent = message;

    this.container.appendChild(toast);

    // Animate in
    requestAnimationFrame(() => {
      toast.classList.add("visible");
    });

    // Auto-remove after timeout
    if (timeout > 0) {
      setTimeout(() => this.remove(toast), timeout);
    }
  }

  // Remove a toast
  static remove(toast) {
    toast.classList.remove("visible");
    setTimeout(() => toast.remove(), 300); // wait for fade-out
  }
}
